
import { defineComponent } from "vue";

import BreadCrumb from "../../components/Common/BreadCrumb.vue";
import IdentitiesContent from "./Components/IdentitiesContent.vue";

export default defineComponent({
  name: "IdentityPage",
  components: {
    BreadCrumb,
    IdentitiesContent,
  },
});
